export default __webpack_public_path__ + "static/media/g-xxl-3.2efc00a7.png";